/** Canonical site origin for SEO (canonical, OG, sitemap). */
export const SITE_ORIGIN =
  (import.meta.env.VITE_PUBLIC_DOMAIN as string | undefined)?.replace(/\/$/, '') ||
  'https://hiromatch.com';

/** Default share image — 1200×630 PNG in public/brand/ */
export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/brand/og-default.png`;

export const NOINDEX_FOLLOW = 'noindex, follow' as const;
export const INDEX_FOLLOW = 'index, follow' as const;
